import { t } from "@/i18n";

interface DegerDagilimTablosuProps {
  ozellikAdi: string;
  dagilim: Record<string, number>;
}

/**
 * "📊 {özellik} değer dağılımı" tablosu — eski `legacy/js/denetim.js:129-136`
 * (görev B). Backend zaten üretiyordu (`app/audit/catalog.py katalog_denetimi`
 * `dagilim` — seçili `ozellik_adi`'nın değer → ürün sayısı dökümü,
 * `run_catalog_audit` bunu `summary.dagilim`'e yazıyor); burada yalnız
 * görüntüleme eklenir. `dagilim` boşsa (hiç ürün denetlenmediyse) hiçbir şey
 * göstermez — legacy `dag.length` kontrolüyle aynı.
 */
export function DegerDagilimTablosu({ ozellikAdi, dagilim }: DegerDagilimTablosuProps) {
  const girdiler = Object.entries(dagilim);
  if (girdiler.length === 0) return null;

  return (
    <section className="card space-y-2">
      <h3 className="font-display text-sm font-bold text-ink">{t("denetim.dagilim.baslik", { ozellik: ozellikAdi })}</h3>
      <div className="overflow-x-auto rounded-lg border-[1.5px] border-line">
        <table className="tbl min-w-[280px]">
          <thead>
            <tr>
              <th scope="col">{t("denetim.dagilim.deger")}</th>
              <th scope="col" className="text-right">
                {t("denetim.dagilim.urun")}
              </th>
            </tr>
          </thead>
          <tbody>
            {girdiler.map(([deger, adet]) => (
              <tr key={deger}>
                <td>{deger}</td>
                <td className="num">{adet}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
